var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcons16PxDelete = function SvgIcons16PxDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EAE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.849 5.096.075.062L8 7.235l2.076-2.077a.541.541 0 0 1 .828.69l-.062.076L8.765 8l2.077 2.076a.541.541 0 0 1-.69.828l-.076-.062L8 8.765l-2.076 2.077a.541.541 0 0 1-.828-.69l.062-.076L7.235 8 5.158 5.924a.541.541 0 0 1 .69-.828"
  }))));
};
export default SvgIcons16PxDelete;